import React, { Component } from 'react';
import { Modal, Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import NumberFormat from 'react-number-format';

import Backend from '../../Backend';
import Connection from '../../Calls';
import GAuth from '../../Images/gauth.png'


var WAValidator = require('multicoin-address-validator');

export default class AddAddress extends Component {
  constructor(props){
    super(props)
    this.state = {
      renderer:'address',
      coinNew:{
        symbol:''
      },
      validateAddres:true,
      address:'',
      tagid:'',
      label:'',
      amount:'',
    }
  }

  cancelAdd(){
    this.setState({
      renderer:'address',
      coinNew:{
        symbol:''
      },
      address:'',
      tagid:'',
      label:'',
      amount:'',
      showLoad:false,digit1: '',digit2: '',digit3: '',digit4: '',digit5: '',digit6: '',
    })
    this.props.closeModal();
  }

  addAddress(){
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showLoad: true });

    if (this.state.address !== "" && this.state.coinNew !== "" && this.state.label != "" && this.state.amount != "") {

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {

        Backend.Check2FA(localStorage.getItem('email'),localStorage.getItem('token'), response.payload.r01, response => {
          if (response.status.code === "0") {
            if(response.payload.status == 'enabled'){
              this.setState({renderer:'2fa'})
            }else{
              this.addAddress2FA()
            }
          }else{
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ showLoad: false });
          }
        });

      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({
        showLoad: false,
        digit1: '',digit2: '',digit3: '',digit4: '',digit5: '',digit6: '',
        renderer:'address'
      });
    }
  }

  addAddress2FA(){
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showLoad: true });

    if (this.state.address !== "" && this.state.coinNew !== "" && this.state.label != "" && this.state.amount != "") {

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var amountToSend=(self.state.selectedCurrency==='usd')?self.calculateCrypto():self.state.amount
        var code = this.state.digit1 + this.state.digit2 + this.state.digit3 + this.state.digit4 + this.state.digit5 + this.state.digit6

        Backend.WhiteListIncert(localStorage.getItem('email'), localStorage.getItem('token'), this.state.coinNew.symbol, this.state.address, this.state.tagid || '-', this.state.label, this.state.amount, code || '-', response.payload.r01, response => {
          if (response.status.code === "0") {
            store.addNotification({
              title: "Success!",
              message: response.payload.message,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.cancelAdd();
            self.props.whiteListPagiation();
          }else{
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
              self.cancelAdd();
          }
        })
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({
        showLoad: false,
        digit1: '',digit2: '',digit3: '',digit4: '',digit5: '',digit6: '',
        renderer:'address'
      });
    }
  }


  validateAddress() {
    const self = this;
    var valid = WAValidator.validate(self.state.address, self.state.coinNew.symbol.toUpperCase());
    if (valid) {
      self.setState({ validateAddres: true });
      if(self.state.coinNew.symbol == 'usdt')
        self.setState({ validateAddres: (self.state.addressW[0] == '1' || self.state.addressW[0] == '3') });
    }
    else {
      self.setState({ validateAddres: false });
    }

    var xrpacoount = localStorage.getItem('xrpAddress');
    if(self.state.address === xrpacoount){
      self.setState({ validateAddres: false });
    }
  }


  calculateCrypto(){
    var calculoCrypto;
    var calculoCrypto = (this.state.amount) / (this.state.usdPrice)
    return calculoCrypto
  }

  calculateUSD(){
    var calculoUsd;
      var calculoUsd = (this.state.amount) * (this.state.usdPrice)
    return calculoUsd
  }



  renderCoinsNew(){
    return this.props.availableCoinsArray.map((item,i)=>{
      return(
        <Dropdown.Item onClick={() => this.setState({ coinNew: item, validateAddres:true, address:'',usdPrice:item.usd_price,selectedCurrency:item.symbol, amount:''})} as="button">
          <Image src={require("../../CryptoIcons/" + item.symbol + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {item.name}
        </Dropdown.Item>
      )
    })
  }

  render(){
    return(
      <Modal className="modal-signup-resend-email" centered aria-labelledby="contained-modal-title-vcenter" show={this.props.showModal} onHide={() => this.props.closeModal()}>
        {this.renderContent()}
      </Modal>
    )
  }

  renderContent(){
    switch (this.state.renderer) {
      case 'address':
        return(
          <Modal.Body>
            <div>
              <p className="title-container-shadow center-text">{this.props.traductions.ModalAddAddress.title}</p>
            </div>
            <div className="container-steps-add-wallet-general">
              <div className="steps-add-wallet-general">
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">{this.props.traductions.ModalAddAddress.L_Wallet}</Form.Label>
                  <Col sm="10">
                    <Dropdown >
                      <Dropdown.Toggle id="dropdown-custom-1">
                        {
                          (this.state.coinNew.symbol)
                          ?
                          <>
                            <Image src={require("../../CryptoIcons/" + this.state.coinNew.symbol + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                            <span>{this.state.coinNew.name} ({this.state.coinNew.symbol})</span>
                          </>
                          :this.props.traductions.L_SelectCoin
                        }
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {this.renderCoinsNew()}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">{this.props.traductions.ModalAddAddress.L_Address}</Form.Label>
                  <Col sm="10">
                    <Form.Control disabled={!this.state.coinNew.symbol} style={(!this.state.validateAddres)?{borderColor:'red'}:{}} className={"input-modal"} type="text" placeholder={this.props.traductions.ModalAddAddress.L_Address} value={this.state.address} onChange={(address) => { this.setState({ address: address.target.value }) }} onKeyUp={() => { this.validateAddress() }} />
                    <div className={(this.state.validateAddres) ?"container-addresses-label-error"  :"container-addresses-label"}>
                      <p className={!this.state.validateAddres ?"label-addresses-captured-error"  :"label-addresses-captured-success" }>{this.props.traductions.ModalAddAddress.L_AddressError}</p>
                    </div>
                  </Col>
                </Form.Group>
                {
                  (this.state.coinNew.symbol == 'xrp')&&
                  <Form.Group as={Row}>
                    <Form.Label column sm="2" className="label-modal">{this.props.traductions.ModalAddAddress.L_Tag}</Form.Label>
                    <Col sm="10">
                      <Form.Control className="input-modal" type="text" placeholder={this.props.traductions.ModalAddAddress.L_Tag} value={this.state.tagid} onChange={(tagid) => { this.setState({ tagid: tagid.target.value }); }} />
                    </Col>
                  </Form.Group>
                }
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">{this.props.traductions.ModalAddAddress.L_Label}</Form.Label>
                  <Col sm="10">
                    <Form.Control className="input-modal" type="text" placeholder={this.props.traductions.ModalAddAddress.L_Label} value={this.state.label} onChange={(label) => { this.setState({ label: label.target.value }); }} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">{this.props.traductions.ModalAddAddress.L_Amount}*</Form.Label>
                    <Col sm="10">
                      <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                        {
                          (this.state.selectedCurrency == 'usd')
                          ? <NumberFormat disabled={!this.state.coinNew.symbol} className='btc-format-input' placeholder={this.props.traductions.ModalAddAddress.P_Amount} decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amount} onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amount: value})}} />
                          : <NumberFormat disabled={!this.state.coinNew.symbol} className='btc-format-input' placeholder={this.state.coinNew.symbol.toUpperCase() + ' ' + this.props.traductions.ModalAddAddress.L_Amount} decimalScale={8} value={this.state.amount} onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amount: value})}} />
                        // : <Form.Control style={{ width: "100%" }} className="input-signup" type="text" placeholder="BTC Amount" value={this.state.amount} onChange={(amount) => { this.setState({ amount: amount.target.value }) }} />
                        }
                        <Button className={(this.state.selectedCurrency === this.state.coinNew.symbol) ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: this.state.coinNew.symbol }) }}>{this.state.coinNew.symbol.toUpperCase()}</Button>
                        <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                      </div>

                        <div className={(this.state.amount) ? "container-addresses-label" : "container-addresses-hidden"}>
                          {
                            (this.state.selectedCurrency == 'usd')
                            ?<p className={"label-addresses-captured-warning"}>{this.props.traductions.ModalAddAddress.L_Amountn1} {Number(this.calculateCrypto()).toFixed(8)} {this.state.coinNew.symbol}</p>
                            :<p className={"label-addresses-captured-warning"}>{this.props.traductions.ModalAddAddress.L_Amountn1} {this.calculateUSD()} usd</p>
                          }
                        </div>
                    </Col>
                </Form.Group>
                <Row>
                  <Col xs={{offset:1,span:10}}>
                    <div className={"container-addresses-label"}>
                      <p className={"label-addresses-captured-warning"}>*{this.props.traductions.ModalAddAddress.L_Amountn2}</p>
                    </div>
                  </Col>
                </Row>

                <Form.Group style={{ marginTop: 70 }}>
                  <Button className="steps-button-wallet-general" style={{ backgroundColor: "#053164" }} onClick={() => { this.addAddress(); }} disabled={this.state.showLoad}>
                    {
                      (this.state.showLoad)
                        ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showLoad} />
                        :this.props.traductions.ModalAddAddress.btn
                    }
                  </Button>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
        )
      break;
      case '2fa':
        return(
          <Modal.Body>
            <div className="border-title-separator-container-left" style={{ width: "100%" }}>
              <p className="title-container-shadow">{this.props.traductionsTwofa.title}</p>
            </div>
            <div className='activate-2fa-titles'>
              <div className='gauth_logo inline-block'>
                <Image src={GAuth}/>
              </div>
              <div className='inline-block'>
                <p className='password-notice'>{this.props.traductionsTwofa.desc}</p>
              </div>
            </div>
            <div style={{ marginTop: 25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Container className="container-google-autenticathor">
                <Row>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref1'
                      ref='digit_ref1'
                      maxlength='1'
                      value={this.state.digit1}
                      onChange={(digit1) => {this._handleChange(1,digit1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref2'
                      ref='digit_ref2'
                      maxlength='1'
                      value={this.state.digit2}
                      onChange={(digit2)=> {this._handleChange(2,digit2)}}
                      onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref3'
                      ref='digit_ref3'
                      maxlength='1'
                      value={this.state.digit3}
                      onChange={(digit3) => {this._handleChange(3,digit3)}}
                      onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref4'
                      ref='digit_ref4'
                      maxlength='1'
                      value={this.state.digit4}
                      onChange={(digit4) => {this._handleChange(4,digit4)}}
                      onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref5'
                      ref='digit_ref5'
                      maxlength='1'
                      value={this.state.digit5}
                      onChange={(digit5) => { this._handleChange(5,digit5)}}
                      onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref6'
                      ref='digit_ref6'
                      maxlength='1'
                      value={this.state.digit6}
                      onChange={(digit6) => { this._handleChange(6,digit6)}}
                      onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button className="virtual_exchange_information_wallets_text-link" variant="link" onClick={() => this.cancelAdd()}>{this.props.traductionsTwofa.cancel}</Button>
            </div>
          </Modal.Body>
        )
      break;

    }
  }


  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.addAddress2FA()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

}
